import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from '../../universal-nav/hooks/useUniversalNavContext';
import { organizeAccountsStructure } from '../utils/organizeAccountsStructure';
export const prepareAccountsListData = async (accountsJson, profilesJson) => {
    const accounts = accountsJson.results || [];
    const profiles = profilesJson.objects || [];
    const output = accounts.map((account) => {
        let avatar = account.logo_url;
        let name = account.name;
        if (account.plan_info.allow_teams === false) {
            name = account.owner.name;
            const profile = profiles.find((p) => p.id === account.owner.id);
            if (profile)
                avatar = profile.photo_url;
        }
        return {
            id: account.id,
            normalizedImageUrl: avatar,
            normalizedName: name,
            planName: account.plan_info.name,
            hasTeams: account.plan_info.allow_teams,
            parentAccountRelationship: account.parent_account_relationship,
            parentAccount: account.parent_account,
        };
    });
    const hasUndefinedValues = Object.values(output).filter((x) => x === undefined).length > 0;
    if (hasUndefinedValues)
        throw Error('Invalid input JSON');
    return organizeAccountsStructure(output);
};
async function fetchData(apiHostname) {
    const accountsResponse = await fetch(`${apiHostname}/api/v4/accounts?limit=9999`, {
        credentials: process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
    });
    const profilesResponse = await fetch(`${apiHostname}/api/v3/profiles`, {
        credentials: process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
    });
    if (!accountsResponse.ok || !profilesResponse.ok) {
        throw new Error('Network response was not ok');
    }
    const accountsJson = await accountsResponse.json();
    const profilesJson = await profilesResponse.json();
    return prepareAccountsListData(accountsJson, profilesJson);
}
export const useQueryAccountsList = () => {
    const { accountsListData: accountsListDataFromProps, apiHostname } = useUniversalNavContext();
    const result = useQuery({
        queryKey: ['accounts'],
        queryFn: () => fetchData(apiHostname),
        enabled: !accountsListDataFromProps,
        initialData: accountsListDataFromProps,
    });
    return Object.assign(Object.assign({}, result), { isLoading: result.isInitialLoading });
};
//# sourceMappingURL=useQueryAccountsList.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
